import * as api from "services/api";

export const GET_PAYMENT_METHODS = "[PAYMENT METHOD] GET_PAYMENT_METHODS";
export const GET_PAYMENT_METHODS_FAILED =
  "[PAYMENT METHOD] GET_PAYMENT_METHODS_FAILED";
export const GET_PAYMENT_METHODS_SUCCESS =
  "[PAYMENT METHOD] GET_PAYMENT_METHODS_SUCCESS";

export const SET_VALUE = "[PAYMENT METHOD] SET_VALUE";
export const CLEAR_VALUE = "[PAYMENT METHOD] CLEAR_VALUE";

export function getPaymentMethods() {
  return async (dispatch, getState) => {
    dispatch({
      type: GET_PAYMENT_METHODS
    });

    const { token } = getState().login;

    let response = await api.sendGet("/PaymentMethod", {
      Authorization: "Bearer " + token
    });

    if (response.ok) {
      let json = await response.json();

      dispatch({
        type: GET_PAYMENT_METHODS_SUCCESS,
        payload: json.model
      });
    } else {
      dispatch({ type: GET_PAYMENT_METHODS_FAILED });
    }
  };
}

export function setValue(payload) {
  return {
    type: SET_VALUE,
    payload
  };
}

export function clearValue() {
  return {
    type: CLEAR_VALUE
  };
}

export function getPaymentMethodsV2(
	skip,
	take,
	filter,
	sort,
	desc,
	toExport,
	callback
) {
	return async (dispatch, getState) => {
		dispatch({
			type: GET_PAYMENT_METHODS
		});

		const { login } = getState();
		const { token } = login;

		let response = await api.sendGet(
			`/PaymentMethod/v2?skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${filter || ""}`,
			{
				Authorization: "Bearer " + token
			}
		);

		if (response.ok) {
			let result = await response.json();

			if (result.isValid) {
				if (toExport) {
					dispatch(setValue({ loading: false }));
				} else {
					dispatch({
						type: GET_PAYMENT_METHODS_SUCCESS,
						payload: result.model
					});

					if (result.params)
						dispatch(
							setValue({
								pages: Math.ceil(result.params.count / take),
								...result.params
							})
						);
				}

				callback && callback(null, result.model);
			} else {
				dispatch({ type: GET_PAYMENT_METHODS_FAILED, payload: result.errors });
				callback && callback(result.errors, result.model);
			}
		} else {
			dispatch({ type: GET_PAYMENT_METHODS_FAILED });
			callback && callback("Ocorreu um erro ao tentar carregar os métodos de pagamento");
		}
	};
}
